import { projectBidRowsListPageParamsSchemaValidator } from "@grafit/shared/utils/sidebar-url-params-schema";
import { createFileRoute } from "@tanstack/react-router";
import { ProjectIndexRedirect } from "../../../pages/project-index-redirect/project-index-redirect";

export const Route = createFileRoute("/_auth/_project/bid/$projectId/")({
  component: () => <ProjectIndexRedirect isInDealContext={false} />,
  validateSearch: projectBidRowsListPageParamsSchemaValidator,
});
